module.exports = __webpack_public_path__ + "static/media/fondo_payaso.20356f65.jpg";